import type { Template } from '@ztechapps/common.contract'
import type { UseLazyDocumentProps, UseLazyDocumentResult } from '../useDocument/useLazyDocument'
import { useLazyDocument } from '../useDocument/useLazyDocument'
import { templateQueries } from './graphql'

/**
 * Get a single template from the db on demand
 */
export const useLazyTemplateDocument = (props: Partial<UseLazyDocumentProps> = {}): UseLazyDocumentResult<Template> => {
  return useLazyDocument<Template>({
    ...templateQueries.singleConfig,
    ...props,
  })
}
